import store from '@/store/store'
import useI18nGlobal from '@/utils/i18n';
const {i18n} = useI18nGlobal();
const { t } = i18n.global;
export default function(editor){
	
		async function _onAction(){
			// await store.dispatch('settingsPopup/imageVideoModeSet', true);
			await store.dispatch('settingsPopup/mediaChoosingToggle', true); // to hide additional media features
			await store.dispatch('mediaContent/setEditorActive', editor.id); // to insert image accordingly
			await store.dispatch('mediaContent/mediaContentToggle', true); // to open media popup above content form
		}
		
		editor.ui.registry.addIcon('media-assets',
			`<svg viewBox="0 0 640 512" width="24" height="24"><path fill="#000000" d="M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"></path></svg>`
		);
		
		editor.ui.registry.addButton('media-assets', {
			tooltip: t('popup.media.title'),
			icon: 'media-assets',
			onAction: _onAction
		});
		
		editor.ui.registry.addMenuItem('media-assets', {
			context: 'insert',
			text: t('popup.media.title'),
			icon: 'media-assets',
			onAction: _onAction
		});
}
